import { render, staticRenderFns } from "./OrganizationAttendedCourses.vue?vue&type=template&id=40edf37c&scoped=true&"
import script from "./OrganizationAttendedCourses.vue?vue&type=script&lang=js&"
export * from "./OrganizationAttendedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40edf37c",
  null
  
)

export default component.exports